export const getApiErrorCode = error => {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  if ("code" in error && typeof error.code === "string") {
    return error.code;
  }

  const responseCode = error.response?.data?.code;
  if (typeof responseCode === "string") {
    return responseCode;
  }

  return undefined;
};

export const isApiErrorWithCode = error => Boolean(getApiErrorCode(error));
